import { useQuery, useMutation } from '@tanstack/react-query';

import Axios from 'axios';
import { queryClient } from 'QueryClientProvider';

const onGetTransactionByID = (ID, family) => Axios.get(`/transactions/${family}/${ID}`);

const useTransaction = (ID, family) => {
    return useQuery({
        queryKey: ['transaction', ID],
        queryFn: () => onGetTransactionByID(ID, family),
        staleTime: 1000,
        cacheTime: 1000,
        retry: false,
        enabled: ID ? true : false,
    });
};

const onAddTransaction = ({ data }) => Axios.post(`/transactions`, data);

const useAddTransaction = () => {
    return useMutation({
        mutationFn: onAddTransaction,
        onSuccess: (data, variables) => {
            forceReloadTransaction(data.ID);
        },
    });
};

const forceReloadTransaction = (ID) => {
    if (ID) {
        queryClient.invalidateQueries({ queryKey: ['transaction', ID] });
    } else {
        queryClient.invalidateQueries({ queryKey: ['transaction'] });
    }
};

export { useTransaction, useAddTransaction, forceReloadTransaction };
